import {
  AfterViewInit,
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { AmKeyboardService } from '@app/shared/components/am-keyboard/am-keyboard.service';

@Component({
  selector: 'am-places-autocomplete-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
  standalone: false,
})
export class SearchInputComponent implements AfterViewInit, OnDestroy {
  @Input() control: FormControl = new FormControl();
  @Output() close = new EventEmitter<void>();
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  constructor(private keyboardService: AmKeyboardService, private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.searchInput) {
        this.searchInput.nativeElement.focus();
      }
    }, 0);
  }

  onInputFocus(): void {
    this.showKeyboard();
  }

  ngOnDestroy(): void {
    this.keyboardService.destroy();
  }

  private showKeyboard(): void {
    if (!this.searchInput) return;

    this.keyboardService.show(
      'text',
      this.searchInput.nativeElement,
      this.control,
      false,
      '',
      true,
      false,
      'keyboard-content',
      false,
      'destination-keyboard'
    );
  }
}
